<template>
  <div id="checkin" class="screen">
    <div class="section checkin-section">
      <form v-on:submit.prevent="checkIn">
        <v-col cols="10" offset="1">
          <v-text-field
              v-model="checkinId"
              label="Check-in ID"
              solo
              autofocus
              autocomplete="off"
              hint="Fill in the ID you see on the slide"
              persistent-hint
          ></v-text-field>
        </v-col>
        <v-btn type="submit" color="primary">Submit</v-btn>
        <span class="fas fa-circle-notch fa-spin fa-2x"
              aria-hidden="true" v-if="checkingPresentation"></span>
      </form>
      <div class="notification is-danger" v-if="noMatchedPresentation">
        No presentation matched that ID.
      </div>
    </div>
  </div>
</template>

<script>
import firebaseApp from '../api/firebaseClient';

export default {
  name: 'Checkin',
  data() {
    return {
      noMatchedPresentation: false,
      checkingPresentation: false,
      checkinId: null
    };
  },
  methods: {
    checkIn() {
      const db = firebaseApp.db;
      const presentationsRef = db.collection('presentations');
      const query = presentationsRef.where('checkinId', '==', this.checkinId);

      this.checkingPresentation = true;
      this.noMatchedPresentation = false;

      query.get().then((querySnapshot) => {
        this.checkingPresentation = false;

        if (querySnapshot.docs.length === 1) {
          const presentationId = querySnapshot.docs[0].id;
          this.$router.push({ name: 'attending', params: { presentationId } });
        } else if (querySnapshot.docs.length === 0) {
          this.noMatchedPresentation = true;
        } else {
          console.log('Multiple matched presentations');
        }
      }).catch((error) => {
        console.log('Error getting document:', error);
      });
    }
  }
};
</script>

<style lang="scss">
  .checkin-section {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Checkin.vue